import React from 'react';
import { useHookstateCallback } from '@hookstate/core';

import { FiMenu } from 'react-icons/fi';
import logo from '../../img/logo.svg';

import LogoutButton from '../LogoutButton';
import { useAppState } from '../../services/state';

import '../../App.css';
import '../../style/Common.css';
import '../../style/Header.css';
import '../../style/Modal.css';

const Header = () => {
  const appState = useAppState();
  const { isSidebarOpen } = appState.get();
  const toggleMenu = useHookstateCallback(
    () => appState.merge({ isSidebarOpen: !isSidebarOpen }),
    [isSidebarOpen]
  );

  return (
    <header className="Header">
      <div className="header-inner d-flex">
        <div className="logo-title-wrapper">
          <div className="logo m-r-1">
            <div className="menu-button-wrapper m-r-2">
              <FiMenu size={'1.5rem'} id="menu-btn" className="menu-btn" onClick={toggleMenu} />
            </div>
            <a href="/boards">
              <img src={logo} alt="circly" />
            </a>
          </div>
        </div>
        <div className="login d-flex justify-content-end">
          <LogoutButton />
        </div>
      </div>
    </header>
  );
};

export default Header;
